import React, {useEffect, useState} from "react";
import {useGlobal} from "../../Store";
import {postData} from "../../Utils/Server";
import Endpoints from "../../Constants/Endpoints";
import {ERROR, Notify, SUCCESS} from "../../Utils/Notify";
import {updateDocumentTitle} from "../../Utils/Common";
import PageLayout from "../Layout/PageLayout";
import {Card, Tabs, FormField, TextInput, Select, Button, DataTable, StatusBadge} from "../UI";
import DatePicker from "../Views/DatePicker";
import TimePicker from "../Views/TimePicker";

const Promo = props => {

    let d = new Date();

    const [globalState, globalActions] = useGlobal();
    const [isLoading, setIsLoading] = useState(false);
    const [activeList, setActiveList] = useState([]);
    const [businessList, setBusinessList] = useState([]);
    const [inactiveList, setInactiveList] = useState([]);

    const [promoCode, setPromoCode] = useState('');
    const [audience, setAudience] = useState('any_user');
    const [business, setBusiness] = useState(0);
    const [promoType, setPromoType] = useState('percentage');
    const [promoMinAmount, setPromoMinAmount] = useState('');
    const [promoValue, setPromoValue] = useState('');
    const [promoBudget, setPromoBudget] = useState('');

    const [startDate, setStartDate] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endDate, setEndDate] = useState('');
    const [endTime, setEndTime] = useState('');

    const [tab, setTab] = useState('new');


    const columns = [
        {
            name: 'Promo code',
            selector: 'promo_code',
            cell: row => <div>
                <p>Code : {row.promo_code}</p>
                <p>Budget : {row.budget}</p>
                <p>Usage : {row.usage}</p>
            </div>,
        },
        {
            name: 'Audience',
            selector: 'audience',
        },
        {
            name: 'Business',
            cell: row => <div><span>{row.business_details.name}</span></div>,
        },
        {
            name: 'Start',
            cell: row => <div><span>{row.start_date_string}</span></div>,
        },
        {
            name: 'End',
            cell: row => <div><span>{row.end_date_string}</span></div>,
        },
        {
            name: 'Status',
            cell: row => <StatusBadge tone={row.status === 1 ? "success" : "danger"}>{row.status === 1 ? "ACTIVE" : "INACTIVE"}</StatusBadge>,
        },
        {
            name: '',
            cell: row => row.status === 0 ? '-' : <Button variant="danger" size="sm"
                                                          onClick={e => deletePromo(row.id)}>Delete</Button>,
        },
    ]


    useEffect(() => {
        updateDocumentTitle("Promotions")
        loadBusinesses()
        loadHistory(1)
        loadHistory(0)
    }, []);

    const loadBusinesses = () => {
        let data = new FormData();
        data.append("status", 1);
        setIsLoading(true);
        postData(Endpoints.BUSINESS_LIST, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                setBusinessList(res.data || []);
                if (res.data.length > 0) {
                    setBusiness(res.data[0].id)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    };

    function deletePromo(id) {
        let data = new FormData();
        data.append("id", id);

        setIsLoading(true)
        postData(Endpoints.DELETE_PROMO, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                Notify(res.success === 1 ? res.data : res.message, res.success === 1 ? SUCCESS : ERROR);
                if (res.success === 1) {
                    loadHistory(1)
                    loadHistory(0)
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }

    const submitForm = e => {
        e.preventDefault();

        let data = new FormData();
        data.append("promo_code", promoCode)
        data.append("audience", audience)
        data.append("business_id", business)
        data.append("promo_type", promoType)
        data.append("promo_min_amount", promoMinAmount)
        data.append("promo_value", promoValue)
        data.append("promo_budget", promoBudget)
        data.append("start_date", startDate)
        data.append("start_time", startTime)
        data.append("end_date", endDate)
        data.append("end_time", endTime)

        setIsLoading(true);

        postData(Endpoints.NEW_PROMO, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    setPromoCode('');
                    setPromoValue('');
                    loadHistory(1)
                    Notify(res.data, SUCCESS);
                } else {
                    if (Array.isArray(res.message)) {
                        Notify(res.message[0], ERROR);
                    } else {
                        Notify(res.message, ERROR);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    function loadHistory(status) {
        let data = new FormData();
        data.append("status", status);
        setIsLoading(true)
        postData(Endpoints.LIST_PROMO, data)
            .then(res => res.json())
            .then(res => {
                setIsLoading(false);
                if (res.success === 1) {
                    if (status === 1) {
                        setActiveList(res.data || []);
                    } else {
                        setInactiveList(res.data || []);
                    }
                }
            })
            .catch((error) => {
                setIsLoading(false);
                console.log(error)
            });
    }


    return (
        <PageLayout title="Promotions">
            <Tabs
                tabs={[
                    {key: "new", label: "Create a new promotion"},
                    {key: "active", label: "Active promotions"},
                    {key: "inactive", label: "Inactive promotions"},
                ]}
                value={tab}
                onChange={setTab}
            />

            {tab === "new" &&
            <Card style={{maxWidth: 640}}>
                <form onSubmit={submitForm}>
                    <FormField label="Promo code">
                        <TextInput type="text"
                                   placeholder={"Promo code"}
                                   value={promoCode}
                                   onChange={e => setPromoCode(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Audience">
                        <Select value={audience}
                                onChange={({target}) => setAudience(target.value)}>
                            <option value={"any_user"}>Any user</option>
                            <option value={"corporate_user"}>Only corporate users</option>
                            <option value={"specific_business"}>Only specific business</option>
                        </Select>
                    </FormField>

                    {audience === "specific_business" &&
                    <FormField label="Select a business">
                        <Select value={business}
                                onChange={({target}) => setBusiness(target.value)}>
                            {businessList.map((i) => <option
                                value={i.id}>{i.name}</option>)}
                        </Select>
                    </FormField>
                    }

                    <FormField label="Promo type">
                        <Select value={promoType}
                                onChange={({target}) => setPromoType(target.value)}>
                            <option value={"percentage"}>Percentage discount</option>
                            <option value={"fixed"}>Fixed amount discount</option>
                        </Select>
                    </FormField>

                    <FormField label={`Promo ${promoType === "fixed" ? "fixed discount value" : "percentage value"}`}>
                        <TextInput type="number"
                                   placeholder={"Value"}
                                   value={promoValue}
                                   onChange={e => setPromoValue(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Minimum amount required">
                        <TextInput type="number"
                                   placeholder={"Min amount"}
                                   value={promoMinAmount}
                                   onChange={e => setPromoMinAmount(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Budget (Promo will deactivate itself when usage value reaches this budget)">
                        <TextInput type="number"
                                   placeholder={"Min amount"}
                                   value={promoBudget}
                                   onChange={e => setPromoBudget(e.target.value)}
                        />
                    </FormField>

                    <FormField label="Start date & time">
                        <div>
                            <DatePicker
                                onDateSelected={(pickerDate, pickerMonth, pickerYear) => {
                                    setStartDate(`${pickerYear}-${pickerMonth}-${pickerDate}`)
                                }}/>

                            <TimePicker onTimeSelected={(pickerTime, pickerMinute) => {
                                console.log(pickerTime, pickerMinute)
                                setStartTime(`${pickerTime}:${pickerMinute}`)
                            }}/>
                        </div>
                    </FormField>

                    <FormField label="End date & time">
                        <div>
                            <DatePicker
                                onDateSelected={(pickerDate, pickerMonth, pickerYear) => {
                                    setEndDate(`${pickerYear}-${pickerMonth}-${pickerDate}`)
                                }}/>

                            <TimePicker onTimeSelected={(pickerTime, pickerMinute) => {
                                console.log(pickerTime, pickerMinute)
                                setEndTime(`${pickerTime}:${pickerMinute}`)
                            }}/>
                        </div>
                    </FormField>

                    <Button type="submit" loading={isLoading}>Add promo</Button>
                </form>
            </Card>
            }

            {tab === "active" &&
            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={activeList}
                    pointerOnHover={true}
                    noHeader={true}
                />
            </Card>
            }

            {tab === "inactive" &&
            <Card padded={false}>
                <DataTable
                    columns={columns}
                    data={inactiveList}
                    pointerOnHover={true}
                    noHeader={true}
                />
            </Card>
            }
        </PageLayout>
    )
};

export default Promo;
